<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px', fullScreenBackdrop: true}"></ngx-loading>
<nb-layout>
  <nb-layout-header>
    <ngx-header></ngx-header>
  </nb-layout-header>
  <nb-layout-column>
    <div class="login-signup">
      <div class="login-image">
        <img src="../../../assets/images/TTN.png" alt="">
      </div>
      <form [formGroup]="loginDetails" (ngSubmit)="login()">
        <div *ngIf="submitted && invalidCredentials" class="error" style="text-align: center">
          <div class="alert custom-alert-danger" role="alert">
            <span class="sr-only">Error:</span>
            Invalid Email or password
          </div>
        </div>
        <div *ngIf="!submitted && invalidCredentials" class="error" style="text-align: center">
          <div class="alert custom-alert-danger" role="alert">
            <span class="sr-only">Error:</span>
            {{invalidCreds}}
          </div>
        </div>
        <div *ngIf="!showSignUpBtn" class="error" style="text-align: center; font-size: 13px !important;">
          <div class="alert custom-alert-danger" role="alert">
            According to our records, you already have an active Username and Password. If you feel you have receiving
            this message in error, please send an email to: ProfileUpdates@TTNFS.com.
          </div>
        </div>
        <div class="col-sm-6 col-md-12 col-lg-12">
          <div>
            <mat-form-field class="full-width">
              <input matInput class="" formControlName="username" placeholder="Email/Username"
                (ngModelChange)="changeInvalidCredentialsStatus()" autofocus>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="full-width">
              <input matInput type="password" class="" formControlName="password" placeholder="Password"
                (ngModelChange)="changeInvalidCredentialsStatus()">
            </mat-form-field>
          </div>
          <div>
            <input type="submit" placeholder="Login" value="SUBMIT">
          </div>
          <div class="btm-form mt-2">
            <a routerLink="/forget-password" class="forget-password"> Forgot Password? </a>
            <a routerLink="/signup" [hidden]="hideSignUpBtn"> Sign up </a>
          </div>
        </div>
      </form>
    </div>
  </nb-layout-column>
  <nb-layout-footer>
    <ngx-footer></ngx-footer>
  </nb-layout-footer>
</nb-layout>
<router-outlet></router-outlet>
